import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { communitiesRoutes } from './communities.routing'
import { UpdateCommunityComponent } from './update-community/update-community.component'
import { CreateCommunityComponent } from './create-community/create-community.component'
import { CommunitiesComponent } from './communities.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    CommunitiesComponent,
    CreateCommunityComponent,
    UpdateCommunityComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(communitiesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [
    CommunitiesComponent,
    CreateCommunityComponent,
    UpdateCommunityComponent,
  ],
})
export class CommunitiesModule {}
